const Modals = () => {
  return (
    <>
      <div
        id="blog-model-reactjs"
        className="modal fade blog-model-con"
        tabindex="-1"
        style={{ display: "none" }}
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">
                  <i className="far fa-times"></i>
                </span>
              </button>
            </div>
            <div className="modal-body">
              <div className="blog-box-item mb-0">
                <div className="blog-img">
                  <figure className="mb-0">
                    <img
                      src="assets/image/reactjs.png"
                      alt="blog-img"
                      className="img-fluid"
                    />
                  </figure>
                </div>
                <div className="blog-content pl-0 pr-0">
                  <div className="blog-auteher-title">
                    <span>By Sajjad Ali</span>
                    <span className="float-lg-right">July 10, 2022</span>
                  </div>
                  {/* <h4>Soluta nobis ose aligen
                                optio cumue
                            </h4> */}
                  <div className="footer-social-icon mb-0">
                    <ul>
                      <li className="d-inline-block ml-4">
                        <a href="https://wa.me/00923003929585">
                          <i className="fab fa-whatsapp d-flex align-items-center justify-content-center"></i>
                        </a>
                      </li>

                      <li className="d-inline-block">
                        {" "}
                        <a href="https://www.fiverr.com/users/creationcue/seller_dashboard">
                          <img src="assets/image/fiverr_logo_icon_169172.png" />
                        </a>
                      </li>

                      <li
                        className="d-inline-block mr-3"
                        style={{ maefinLeft: "10px" }}
                      >
                        <a href="https://www.upwork.com/freelancers/~0121c3f7eb8808f732">
                          <img
                            src="assets/image/upwork_logo_icon_170310.png"
                            style={{ width: "50px", marginRight: "10px" }}
                          />
                        </a>
                      </li>

                      <li className="d-inline-block">
                        <a href="https://www.linkedin.com/in/sajjad-laghari-59673921b/">
                          <i className="fab fa-linkedin-in d-flex align-items-center justify-content-center"></i>
                        </a>
                      </li>

                      <li className="d-inline-block ml-4">
                        <a href="https://github.com/Sajjadlaghari">
                          <i className="fab fa-github d-flex align-items-center justify-content-center"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="blog-model-discord"
        className="modal fade blog-model-con"
        tabindex="-1"
        style={{ display: "none" }}
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">
                  <i className="far fa-times"></i>
                </span>
              </button>
            </div>
            <div className="modal-body">
              <div className="blog-box-item mb-0">
                <div className="blog-img">
                  <figure className="mb-0">
                    <img
                      src="assets/image/discord.png"
                      alt="blog-img"
                      className="img-fluid"
                    />
                  </figure>
                </div>
                <div className="blog-content pl-0 pr-0">
                  <div className="blog-auteher-title">
                    <span>By Sajjad Ali</span>
                    <span className="float-lg-right">July 10, 2022</span>
                  </div>
                  {/* <h4>Soluta nobis ose aligen
                                optio cumue
                            </h4> */}
                  <div className="footer-social-icon mb-0">
                    <ul>
                      <li className="d-inline-block ml-4">
                        <a href="https://wa.me/00923003929585">
                          <i className="fab fa-whatsapp d-flex align-items-center justify-content-center"></i>
                        </a>
                      </li>

                      <li className="d-inline-block">
                        {" "}
                        <a href="https://www.fiverr.com/users/creationcue/seller_dashboard">
                          <img src="assets/image/fiverr_logo_icon_169172.png" />
                        </a>
                      </li>

                      <li
                        className="d-inline-block mr-3"
                        style={{ maefinLeft: "10px" }}
                      >
                        <a href="https://www.upwork.com/freelancers/~0121c3f7eb8808f732">
                          <img
                            src="assets/image/upwork_logo_icon_170310.png"
                            style={{ width: "50px", marginRight: "10px" }}
                          />
                        </a>
                      </li>

                      <li className="d-inline-block">
                        <a href="https://www.linkedin.com/in/sajjad-laghari-59673921b/">
                          <i className="fab fa-linkedin-in d-flex align-items-center justify-content-center"></i>
                        </a>
                      </li>

                      <li className="d-inline-block ml-4">
                        <a href="https://github.com/Sajjadlaghari">
                          <i className="fab fa-github d-flex align-items-center justify-content-center"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="model-django"
        className="modal fade blog-model-con"
        tabindex="-1"
        style={{ display: "none" }}
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">
                  <i className="far fa-times"></i>
                </span>
              </button>
            </div>
            <div className="modal-body">
              <div className="blog-box-item mb-0">
                <div className="blog-img">
                  <figure className="mb-0">
                    <img
                      src="assets/image/ecomdjang.png"
                      alt="blog-img"
                      className="img-fluid"
                    />
                  </figure>
                </div>
                <div className="blog-content pl-0 pr-0">
                  <div className="blog-auteher-title">
                    <span>By Sajjad Ali</span>
                    <span className="float-lg-right">July 10, 2022</span>
                  </div>
                  {/* <h4>Soluta nobis ose aligen
                                optio cumue
                            </h4> */}
                  <div className="footer-social-icon mb-0">
                    <ul>
                      <li className="d-inline-block ml-4">
                        <a href="https://wa.me/00923003929585">
                          <i className="fab fa-whatsapp d-flex align-items-center justify-content-center"></i>
                        </a>
                      </li>

                      <li className="d-inline-block">
                        {" "}
                        <a href="https://www.fiverr.com/users/creationcue/seller_dashboard">
                          <img src="assets/image/fiverr_logo_icon_169172.png" />
                        </a>
                      </li>

                      <li
                        className="d-inline-block mr-3"
                        style={{ maefinLeft: "10px" }}
                      >
                        <a href="https://www.upwork.com/freelancers/~0121c3f7eb8808f732">
                          <img
                            src="assets/image/upwork_logo_icon_170310.png"
                            style={{ width: "50px", marginRight: "10px" }}
                          />
                        </a>
                      </li>

                      <li className="d-inline-block">
                        <a href="https://www.linkedin.com/in/sajjad-laghari-59673921b/">
                          <i className="fab fa-linkedin-in d-flex align-items-center justify-content-center"></i>
                        </a>
                      </li>

                      <li className="d-inline-block ml-4">
                        <a href="https://github.com/Sajjadlaghari">
                          <i className="fab fa-github d-flex align-items-center justify-content-center"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="model-laravel-website"
        className="modal fade blog-model-con"
        tabindex="-1"
        style={{ display: "none" }}
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">
                  <i className="far fa-times"></i>
                </span>
              </button>
            </div>
            <div className="modal-body">
              <div className="blog-box-item mb-0">
                <div className="blog-img">
                  <figure className="mb-0">
                    <img
                      src="assets/image/laravelHos.png"
                      alt="blog-img"
                      className="img-fluid"
                    />
                  </figure>
                </div>
                <div className="blog-content pl-0 pr-0">
                  <div className="blog-auteher-title">
                    <span>By Sajjad Ali</span>
                    <span className="float-lg-right">July 10, 2022</span>
                  </div>
                  {/* <h4>Soluta nobis ose aligen
                                optio cumue
                            </h4> */}
                  <div className="footer-social-icon mb-0">
                    <ul>
                      <li className="d-inline-block ml-4">
                        <a href="https://wa.me/00923003929585">
                          <i className="fab fa-whatsapp d-flex align-items-center justify-content-center"></i>
                        </a>
                      </li>

                      <li className="d-inline-block">
                        {" "}
                        <a href="https://www.fiverr.com/users/creationcue/seller_dashboard">
                          <img src="assets/image/fiverr_logo_icon_169172.png" />
                        </a>
                      </li>

                      <li
                        className="d-inline-block mr-3"
                        style={{ maefinLeft: "10px" }}
                      >
                        <a href="https://www.upwork.com/freelancers/~0121c3f7eb8808f732">
                          <img
                            src="assets/image/upwork_logo_icon_170310.png"
                            style={{ width: "50px", marginRight: "10px" }}
                          />
                        </a>
                      </li>

                      <li className="d-inline-block">
                        <a href="https://www.linkedin.com/in/sajjad-laghari-59673921b/">
                          <i className="fab fa-linkedin-in d-flex align-items-center justify-content-center"></i>
                        </a>
                      </li>

                      <li className="d-inline-block ml-4">
                        <a href="https://github.com/Sajjadlaghari">
                          <i className="fab fa-github d-flex align-items-center justify-content-center"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="model-mobile-screen-website"
        className="modal fade blog-model-con"
        tabindex="-1"
        style={{ display: "none" }}
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">
                  <i className="far fa-times"></i>
                </span>
              </button>
            </div>
            <div className="modal-body">
              <div className="blog-box-item mb-0">
                <div className="blog-img">
                  <figure className="mb-0">
                    <img
                      src="assets/image/Mobile-Design.png"
                      alt="blog-img"
                      className="img-fluid"
                    />
                  </figure>
                </div>
                <div className="blog-content pl-0 pr-0">
                  <div className="blog-auteher-title">
                    <span>By Sajjad Ali</span>
                    <span className="float-lg-right">July 10, 2022</span>
                  </div>
                  {/* <h4>Soluta nobis ose aligen
                                optio cumue
                            </h4> */}
                  <div className="footer-social-icon mb-0">
                    <ul>
                      <li className="d-inline-block ml-4">
                        <a href="https://wa.me/00923003929585">
                          <i className="fab fa-whatsapp d-flex align-items-center justify-content-center"></i>
                        </a>
                      </li>

                      <li className="d-inline-block">
                        {" "}
                        <a href="https://www.fiverr.com/users/creationcue/seller_dashboard">
                          <img src="assets/image/fiverr_logo_icon_169172.png" />
                        </a>
                      </li>

                      <li
                        className="d-inline-block mr-3"
                        style={{ maefinLeft: "10px" }}
                      >
                        <a href="https://www.upwork.com/freelancers/~0121c3f7eb8808f732">
                          <img
                            src="assets/image/upwork_logo_icon_170310.png"
                            style={{ width: "50px", marginRight: "10px" }}
                          />
                        </a>
                      </li>

                      <li className="d-inline-block">
                        <a href="https://www.linkedin.com/in/sajjad-laghari-59673921b/">
                          <i className="fab fa-linkedin-in d-flex align-items-center justify-content-center"></i>
                        </a>
                      </li>

                      <li className="d-inline-block ml-4">
                        <a href="https://github.com/Sajjadlaghari">
                          <i className="fab fa-github d-flex align-items-center justify-content-center"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="mobile-app-modal"
        className="modal fade blog-model-con"
        tabindex="-1"
        style={{ display: "none" }}
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">
                  <i className="far fa-times"></i>
                </span>
              </button>
            </div>
            <div className="modal-body">
              <div className="blog-box-item mb-0">
                <div className="blog-img">
                  <figure className="mb-0">
                    <img
                      src="assets/image/mobileapp.png"
                      alt="blog-img"
                      className="img-fluid"
                    />
                  </figure>
                </div>
                <div className="blog-content pl-0 pr-0">
                  <div className="blog-auteher-title">
                    <span>By Sajjad Ali</span>
                    <span className="float-lg-right">July 10, 2022</span>
                  </div>
                  {/* <h4>Soluta nobis ose aligen
                                optio cumue
                            </h4> */}
                  <div className="footer-social-icon mb-0">
                    <ul>
                      <li className="d-inline-block ml-4">
                        <a href="https://wa.me/00923003929585">
                          <i className="fab fa-whatsapp d-flex align-items-center justify-content-center"></i>
                        </a>
                      </li>

                      <li className="d-inline-block">
                        {" "}
                        <a href="https://www.fiverr.com/users/creationcue/seller_dashboard">
                          <img src="assets/image/fiverr_logo_icon_169172.png" />
                        </a>
                      </li>

                      <li
                        className="d-inline-block mr-3"
                        style={{ maefinLeft: "10px" }}
                      >
                        <a href="https://www.upwork.com/freelancers/~0121c3f7eb8808f732">
                          <img
                            src="assets/image/upwork_logo_icon_170310.png"
                            style={{ width: "50px", marginRight: "10px" }}
                          />
                        </a>
                      </li>

                      <li className="d-inline-block">
                        <a href="https://www.linkedin.com/in/sajjad-laghari-59673921b/">
                          <i className="fab fa-linkedin-in d-flex align-items-center justify-content-center"></i>
                        </a>
                      </li>

                      <li className="d-inline-block ml-4">
                        <a href="https://github.com/Sajjadlaghari">
                          <i className="fab fa-github d-flex align-items-center justify-content-center"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="online-blogging-application"
        className="modal fade blog-model-con"
        tabindex="-1"
        style={{ display: "none" }}
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">
                  <i className="far fa-times"></i>
                </span>
              </button>
            </div>
            <div className="modal-body">
              <div className="blog-box-item mb-0">
                <div className="blog-img">
                  <figure className="mb-0">
                    <img
                      src="assets/image/blogging.png"
                      alt="blog-img"
                      className="img-fluid"
                    />
                  </figure>
                </div>
                <div className="blog-content pl-0 pr-0">
                  <div className="blog-auteher-title">
                    <span>By Sajjad Ali</span>
                    <span className="float-lg-right">July 10, 2022</span>
                  </div>
                  {/* <h4>Soluta nobis ose aligen
                                optio cumue
                            </h4> */}
                  <div className="footer-social-icon mb-0">
                    <ul>
                      <li className="d-inline-block ml-4">
                        <a href="https://wa.me/00923003929585">
                          <i className="fab fa-whatsapp d-flex align-items-center justify-content-center"></i>
                        </a>
                      </li>

                      <li className="d-inline-block">
                        {" "}
                        <a href="https://www.fiverr.com/users/creationcue/seller_dashboard">
                          <img src="assets/image/fiverr_logo_icon_169172.png" />
                        </a>
                      </li>

                      <li
                        className="d-inline-block mr-3"
                        style={{ maefinLeft: "10px" }}
                      >
                        <a href="https://www.upwork.com/freelancers/~0121c3f7eb8808f732">
                          <img
                            src="assets/image/upwork_logo_icon_170310.png"
                            style={{ width: "50px", marginRight: "10px" }}
                          />
                        </a>
                      </li>

                      <li className="d-inline-block">
                        <a href="https://www.linkedin.com/in/sajjad-laghari-59673921b/">
                          <i className="fab fa-linkedin-in d-flex align-items-center justify-content-center"></i>
                        </a>
                      </li>

                      <li className="d-inline-block ml-4">
                        <a href="https://github.com/Sajjadlaghari">
                          <i className="fab fa-github d-flex align-items-center justify-content-center"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="ecommerce-reactjs"
        className="modal fade blog-model-con"
        tabindex="-1"
        style={{ display: "none" }}
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">
                  <i className="far fa-times"></i>
                </span>
              </button>
            </div>
            <div className="modal-body">
              <div className="blog-box-item mb-0">
                <div className="blog-img">
                  <figure className="mb-0">
                    <img
                      src="./assets/image/ecomeedjngo.png"
                      alt="blog-img"
                      className="img-fluid"
                    />
                  </figure>
                </div>
                <div className="blog-content pl-0 pr-0">
                  <div className="blog-auteher-title">
                    <span>By Sajjad Ali</span>
                    <span className="float-lg-right">July 10, 2022</span>
                  </div>
                  {/* <h4>Soluta nobis ose aligen
                                optio cumue
                            </h4> */}
                  <div className="footer-social-icon mb-0">
                    <ul>
                      <li className="d-inline-block ml-4">
                        <a href="https://wa.me/00923003929585">
                          <i className="fab fa-whatsapp d-flex align-items-center justify-content-center"></i>
                        </a>
                      </li>

                      <li className="d-inline-block">
                        {" "}
                        <a href="https://www.fiverr.com/users/creationcue/seller_dashboard">
                          <img src="assets/image/fiverr_logo_icon_169172.png" />
                        </a>
                      </li>

                      <li
                        className="d-inline-block mr-3"
                        style={{ maefinLeft: "10px" }}
                      >
                        <a href="https://www.upwork.com/freelancers/~0121c3f7eb8808f732">
                          <img
                            src="assets/image/upwork_logo_icon_170310.png"
                            style={{ width: "50px", marginRight: "10px" }}
                          />
                        </a>
                      </li>

                      <li className="d-inline-block">
                        <a href="https://www.linkedin.com/in/sajjad-laghari-59673921b/">
                          <i className="fab fa-linkedin-in d-flex align-items-center justify-content-center"></i>
                        </a>
                      </li>

                      <li className="d-inline-block ml-4">
                        <a href="https://github.com/Sajjadlaghari">
                          <i className="fab fa-github d-flex align-items-center justify-content-center"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Modals;
